import { createReducer } from 'redux-starter-kit'

// Ritos store
import { benzobotDefaultState, benzobotActionTypes } from './index'

// === Reducers ===

const benzobot = createReducer(benzobotDefaultState, {
  [benzobotActionTypes.BENZOBOT_RESET]: draft => {
    Object.keys(benzobotDefaultState).forEach(key => {
      draft[key] = benzobotDefaultState[key]
    })
  },

  [benzobotActionTypes.BENZOBOT_UPDATE]: (draft, action) => {
    draft.stations = action.payload.data.stations.map(station => ({
      ...station,
      fuelTypeStr: station.price_list.reduce((prevVal, currVal, idx) => {
        let fuel = action.payload.data.fuel_types.find(
          f => f.id === currVal.fuel_type_id
        )
        return idx === 0 ? fuel.name : prevVal + ', ' + fuel.name
      }, ''),
    }))
    draft.fuelTypes = action.payload.data.fuel_types
  },

  [benzobotActionTypes.BENZOBOT_DETAILS_UPDATE]: (draft, action) => {
    draft.details = action.payload.data
  },

  [benzobotActionTypes.BENZOBOT_SELECTED_UPDATE]: (draft, action) => {
    draft.selected = {
      ...draft.selected,
      ...action.payload.data,
    }
  },
})

// === Exports ===

export const benzobotReducers = {
  benzobot,
}
